import * as React from "react";
import CaseSettingsV2Screen from "./CaseSettingsV2Screen";

interface CaseSettingsV2ActivityProps {
  showMyStaffingPreferencesOption: boolean;
  onClickGoBack: () => void;
  onClickMyAvailability: () => void;
  onClickMyStaffingPreferences: () => void;
}

const CaseSettingsV2Activity = (props: CaseSettingsV2ActivityProps) => {
  return (
    <>
      <CaseSettingsV2Screen
        showMyStaffingPreferencesOption={props.showMyStaffingPreferencesOption}
        onClickGoBack={props.onClickGoBack}
        onClickMyAvailability={props.onClickMyAvailability}
        onClickMyStaffingPreferences={props.onClickMyStaffingPreferences}
      />
    </>
  );
};

export default CaseSettingsV2Activity;
